import con from '../../../connection';
var path = '/accounts';
var accounts = function (url) { return function (member_id) { return ({
    post: function (param) { return con.post(url + path + "/" + member_id, param); },
}); }; };
export default accounts;
